import { FAQPage, WithContext } from 'schema-dts'
import { DOMAIN } from '@/root/constants'
import { USStockChartProps } from '@/stories/components/USStocksDetail/USStockChart'

export default function getChildPageSEOData({
  stockData,
  path,
  faqs,
  isEtf,
}: {
  stockData: USStockChartProps['stockData'] | undefined
  path: string
  faqs?: Array<{ question: string; answer: string[] | string }>
  isEtf?: boolean
  exchangeRateFromETFData?: number
}) {
  const name = stockData?.overview?.company_name
  const ticker = stockData?.overview?.ticker
  const price = stockData?.overview?.live_price
  const exchange = stockData?.overview?.exchange

  const title = isEtf
    ? `${name} Share Price Today (${exchange}: ${ticker}) - ${name} Stock Price Live Quote | INDmoney`
    : `${name} (${ticker}) Live Share Price, Invest From India`

  const description = isEtf
    ? `${name} Share Price Live: Check ${exchange}: ${ticker} - ${name} stock price in INR & USD, plus analyst ratings, financials, and forecasts to aid informed decisions on ${name} Stock with INDmoney.`
    : `Track ${name} (${ticker}) share price live with INDmoney. Get real-time stock quotes, interactive charts, latest news, financials, and in-depth analysis to help you make informed investment decisions.`

  const schemas: WithContext<FAQPage>[] = []

  if (faqs && Array.isArray(faqs) && faqs.length) {
    let finalFaqs: Array<{ question: string; answer: string }> = []

    const normalisedFaqs = faqs.map(faq => {
      return {
        question: faq.question,
        answer:
          typeof faq.answer === 'string' ? faq.answer : faq.answer.join(' '),
      }
    })

    finalFaqs = [...finalFaqs, ...normalisedFaqs]

    schemas.push({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      name: `${name ?? ''} Share Price: ${ticker ?? ''} (${
        name ?? ''
      }) Stock Price Today & Updates | INDmoney`,
      description: `Buy ${name} Shares from India at $${price} (0 Commission) today. Start investing in ${name} ${
        isEtf ? '' : 'stocks'
      } from India now with fractional investing only on INDmoneyapp`,
      url: `${DOMAIN}${path}`,
      mainEntity: finalFaqs.map(({ question, answer }) => {
        return {
          '@type': 'Question',
          name: question || '',
          acceptedAnswer: {
            '@type': 'Answer',
            text: answer,
          },
        }
      }),
    })
  }

  const urlObj = new URL(`${DOMAIN}${path}`)
  const canonicalUrl = `${urlObj.origin}${urlObj.pathname}`

  const retVal = {
    title,
    description,
    image: stockData?.overview?.logo,
    canonicalUrl,
    schemas,
  }

  return retVal
}
